module.exports = __webpack_public_path__ + "static/media/surveillance.3b807722.svg";